import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import FunnelProgressBar from './FunnelProgressBar';

const EventFunnel = () => {
  const funnelData = [
    {
      name: 'Conversations → Event Click',
      value: 0,
    },
    {
      name: 'Event Click → RSVP',
      value: 0,
    },
    {
      name: 'RSVP → Paid',
      value: 0,
    },
    {
      name: 'Paid → Attended',
      value: 0,
    },
  ];

  return (
    <Box sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium' }}>
          Event Funnel
        </Typography>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          mt: 3,
        }}
      >
        {funnelData.map((response, index) => (
          <Grid container key={index} alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={8}>
              <FunnelProgressBar value={response.value} formatLabel={(v) => `${v}%`} />
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ fontSize: 14 }}>{response.name}</Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default EventFunnel;
